export default __webpack_public_path__ + "static/media/AXSIGN.513943c2.png";